import React from 'react';
import { trackCustom } from '../utils/tracking';
const links = [{
  label: 'Build your X1',
  href: '#build-your-x1'
}, {
  label: 'Lens system',
  href: '#lenses'
}, {
  label: 'How to use',
  href: '#guide'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'Track order',
  href: '/track'
}];
export function SiteNav() {
  return <header className="sticky top-0 z-40 border-b border-white/10 bg-ink-950/95 backdrop-blur" data-id="element-1302" data-mp="35nmt6ctklxgx">
      <nav aria-label="Main" className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-2 sm:px-6 lg:px-8 lg:py-3" data-id="element-1303" data-mp="31o5o3ki232ca">
        <a href="#top" className="shrink-0" data-id="element-1304" data-mp="2rnv9bvgdhmv0">
          <span className="block font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-offwhite sm:text-3xl" data-id="element-1305" data-mp="2ron45425bgk8">
            Grit<span className="text-grit-500" data-id="element-1306" data-mp="pwrwczj0fw7a">Vue</span>
            <sup className="ml-0.5 align-super text-[9px] text-steel-400" data-id="element-1307" data-mp="pw8qwiajr0a5">™</sup>
          </span>
          <span className="mt-0.5 hidden text-[9px] font-semibold uppercase tracking-[0.3em] text-steel-400 sm:block" data-id="element-1308" data-mp="kygqt0zr07uv">
            See the job through
          </span>
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-1309" data-mp="dzgpxsj6st1o">
          {links.map(link => <li key={link.href} data-id="element-1310" data-mp="3v7vmvgtofz4e">
              <a href={link.href} className="text-xs font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1311" data-mp="3v8wzvqu96vor">
                {link.label}
              </a>
            </li>)}
        </ul>

        <a href="#build-your-x1" onClick={() => trackCustom('nav_cta_clicked', {
        target: 'build'
      })} className="inline-flex shrink-0 items-center whitespace-nowrap bg-grit-500 px-3 py-2 font-display text-base font-extrabold uppercase leading-none tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:px-4 sm:text-lg" data-id="element-1312" data-mp="wr9gzhep446r">
          Build your X1<span className="hidden sm:inline" data-id="element-1313" data-mp="1palpwli36zzy">&nbsp;— from $29.95</span>
        </a>
      </nav>

      <ul aria-label="Sections" className="flex gap-5 overflow-x-auto border-t border-white/10 px-4 py-1.5 [-ms-overflow-style:none] [scrollbar-width:none] lg:hidden [&::-webkit-scrollbar]:hidden" data-id="element-1314" data-mp="1kcbv4c09y1ev">
        {links.map(link => <li key={link.href} data-id="element-1315" data-mp="1be87na5qaukf">
            <a href={link.href} className="whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1316" data-mp="16dc6v5goboj8">
              {link.label}
            </a>
          </li>)}
      </ul>
    </header>;
}